export const normalizeCampaignStatus = status => {
    if (status === 1 || status === '1') {
        return 'completed';
    }

    if (status === 0 || status === '0') {
        return 'active';
    }

    return status?.toString?.() || null;
};

export const resolveCampaignStatus = (...candidates) => {
    const normalizedCandidates = candidates
        .flatMap(candidate => {
            if (!candidate) {
                return [];
            }

            if (typeof candidate === 'object') {
                return [candidate.campaign_status, candidate.status];
            }

            return [candidate];
        })
        .map(normalizeCampaignStatus)
        .filter(Boolean);

    if (normalizedCandidates.includes('completed')) {
        return 'completed';
    }

    return normalizedCandidates[0] || null;
};

export const resolveEditSubmitStatus = async ({
    originalStatus,
    listedCampaign,
    loadCampaign,
}) => {
    const knownStatus = resolveCampaignStatus(originalStatus, listedCampaign);

    if (knownStatus === 'completed' || typeof loadCampaign !== 'function') {
        return knownStatus;
    }

    try {
        const fetchedCampaign = await loadCampaign();
        return resolveCampaignStatus(
            originalStatus,
            listedCampaign,
            fetchedCampaign
        );
    } catch (error) {
        return knownStatus;
    }
};
